/* eslint-disable no-undef */
/* eslint-disable no-redeclare */
/* eslint-disable react/prop-types */
/* eslint-disable semi */
/* eslint-disable no-unused-vars */
/* eslint-disable react/display-name */
import axios from 'axios';
import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
// Strap
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
  Table,
  Collapse,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';

// Table
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
// Breadcrumbs
import Breadcrumbs from '../../components/Common/Breadcrumb';
// Toast
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
// Iotera
import Result from 'iotera-base/result';
import { safeDeepGet, safeDeepSet } from 'iotera-base/utility/json';
import { buildTitle, buttonList } from 'Apps';
// Redux
import { connect } from 'react-redux';
import {
  readPlanogramRetail,
  updatePlanogramRetail,
  list_history,
} from '../../store/business-point/actions';
import makeAnimated from 'react-select/animated';
import ReactExport from 'react-data-export';
import { CircularProgress } from '@material-ui/core';
import ModalNotification from './Component/ModalNotification';
import VMLayout from './Component/VMLayout';
import ColumnLayout from './Component/ColumnLayout';
import columnBuilderXy from './Component/ColumnBuilderXy';
import ColumnsPrice from './Component/ColumnPriceBuilder';
import column2BuilderXy from './Component/Column2BuilderXy';
let role = '';
const obj = JSON.parse(localStorage.getItem('role'));
if (obj != null) {
  role = obj.role;
}
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let buildPlanogramList = {};
let buildColumnList = {};
let removed = [];

let dataInput = [];
class BusinessPointPlanogram extends Component {
  constructor(props) {
    super(props);
   
    this.state = {
      confirm_alert: false,
      buttonValue: [],
      dataInput,
    };
    var editable = true;
    if (role == 'refiller') {
      editable = false;
    }

    const buildPlanogram = (selection, planogramMap) => {
      const product = safeDeepGet(planogramMap, [selection, 'product'], '');
      const nameProduct = safeDeepGet(
        planogramMap,
        [selection, 'nameProduct'],
        ''
      );
      const price = safeDeepGet(planogramMap, [selection, 'price'], 0);
      const stock = safeDeepGet(planogramMap, [selection, 'stock'], 0);
      const order = safeDeepGet(planogramMap, [selection, 'order'], 0);
      const hpp = safeDeepGet(planogramMap, [selection, 'hpp'], 0);
      const share = safeDeepGet(planogramMap, [selection, 'share'], 0);
      const column = safeDeepGet(
        planogramMap,
        [selection.slice(1, 4), 'column'],
        ''
      );
      if (column) {
        var text = column.split(',');
        var arr_column = [];
      }
      for (const i in text) {
        arr_column.push({
          label: text[i],
          value: text[i],
        });
      }
      // this.state.dataInput['1'] = arr_column;
      // this.state.dataInput[selection] = arr_column;
      const active =
        safeDeepGet(planogramMap, [selection, 'active'], false) === true
          ? 'on'
          : 'off';
      var stockColumn = 0;
      for (const value in arr_column) {
        const stock = safeDeepGet(
          planogramMap,
          [arr_column[value].value, 'stock'],
          0
        );
        stockColumn += stock;
      }
      return {
        key: selection,
        selection,
        product,
        nameProduct,
        price,
        stock,
        order,
        active,
        column,
        arr_column,
        stockColumn,
        hpp,
        share,
      };
    };
    buildPlanogramList = planogramMap => {
      const planogramList = [];
      const columnList = safeDeepGet(
        this.props,
        ['readPlanogramResult', 'column'],
        []
      );
      for (const i in columnList) {
        const column = columnList[i];
        planogramList.push(buildPlanogram(column, planogramMap));
      }
      return planogramList;
    };
    buildColumnList = (planogramMap, productMap) => {
      const columnButtonList = [];
      const butttonList = safeDeepGet(
        this.props,
        ['readPlanogramResult', 'button'],
        []
      );
      for (const i in butttonList) {
        const button = butttonList[i];
        columnButtonList.push(
          buildColumnButton(button, planogramMap, productMap)
        );
      }
      return columnButtonList;
    };
    const buildColumnButton = (selection, planogramMap) => {
      const column = safeDeepGet(planogramMap, [selection, 'column'], '');
      const product = safeDeepGet(planogramMap, [selection, 'product'], '');
      const nameProduct = safeDeepGet(
        planogramMap,
        [selection, 'nameProduct'],
        ''
      );
      const price = safeDeepGet(planogramMap, [selection, 'price'], 0);
      const order = safeDeepGet(planogramMap, [selection, 'order'], 0);

      const active =
        safeDeepGet(planogramMap, [selection, 'active'], false) === true
          ? 'on'
          : 'off';

      if (column) {
        var text = column.split(',');
        var arr_column = [];
      }
      for (const i in text) {
        arr_column.push({
          label: text[i].toString(),
          value: text[i].toString(),
        });
      }
      const { dataInput } = this.state;
      dataInput[selection] = arr_column;
      var stockColumn = 0;
      for (const value in arr_column) {
        const stock = safeDeepGet(
          planogramMap,
          [arr_column[value].value, 'stock'],
          0
        );
        stockColumn += stock;
      }
      return {
        key: selection,
        selection,
        column,
        dataInput,
        arr_column,
        product,
        nameProduct,
        price,
        order,
        active,
        stockColumn,
      };
    };
    const { data, type } = props;
    const deviceId = safeDeepGet(data, 'deviceId');
    const deviceType = type;
    const massage = safeDeepGet(this.props, ['result', 'message'], {});
    this.state = {
      isLoading: true,
      dataPrice: {},
      deviceType,
      listButton: buttonList,
      buttonValue: [],
      dataInput,
      massage,
      deviceId,
      col1: false,
      col2: true,
      modal: true,
      columns: columnBuilderXy({}),
      columnsPrice: ColumnsPrice({}),
      columnsButton: column2BuilderXy({}),
      planogram: buildPlanogramList({}),
      buttonColumns: buildColumnList({}),
      button: buildColumnList({}),
      productMap: {},
      serverless_code: 20,
      modalPlanogram: false,
      planogram_history: [],
    };

    this.tableRef = React.createRef();
    this.buttonRef = React.createRef();
    this.priceRef = React.createRef();
    this.t_col1 = this.t_col1.bind(this);
    this.t_col2 = this.t_col2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    // this.handleOnClick = this.handleOnClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleValidDate = this.handleValidDate.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handleImage = this.handleImage.bind(this);
    this.togglePlanogram = this.togglePlanogram.bind(this);
  }
  togglePlanogram() {
    this.setState(prevState => ({
      modalPlanogram: !prevState.modalPlanogram,
    }));
  }
  handlePriceChange = value => {
    const product = safeDeepGet(value, 'product', '');
    safeDeepSet(this.state.dataPrice, product, value);
  };
  t_col1() {
    this.setState({
      col1: !this.state.col1,
    });
  }
  t_col2() {
    this.setState({
      col2: !this.state.col2,
    });
  }
  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }
  get_history() {
    const { deviceId } = this.state;
    const payload = {
      device_id: deviceId,
    };
    this.props.GetHistory(payload);
  }
  async componentDidMount() {
    const { deviceId } = this.state;
    const response = await axios.get(
      'https://asia-southeast2-iotera-vending.cloudfunctions.net/getTime'
    );
    const body = response.data;
    this.setState({
      timeStampNow: body.timestamp,
    });
    this.props.ReadPlanogram(deviceId);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.readPlanogramResult !== prevProps.readPlanogramResult) {
      const code = safeDeepGet(
        this.props,
        ['readPlanogramResult', 'code'],
        Result.UNKNOWN_ERROR
      );
      if (code === Result.SUCCESS) {
        const productMap = safeDeepGet(
          this.props,
          ['readPlanogramResult', 'body', 'products'],
          {}
        );
        const imageMap = safeDeepGet(
          this.props,
          ['readPlanogramResult', 'body', 'images'],
          {}
        );
        const waitResult = safeDeepGet(
          this.props,
          ['readPlanogramResult', 'waitResult'],
          true
        );
        const columnOptions = safeDeepGet(
          this.props,
          ['readPlanogramResult', 'columnOptions'],
          []
        );
        const buttonOptions = safeDeepGet(
          this.props,
          ['readPlanogramResult', 'buttonOptions'],
          []
        );
        const planogramMap = safeDeepGet(
          this.props,
          ['readPlanogramResult', 'body', 'planogram'],
          {}
        );
        const history = safeDeepGet(
          this.props,
          ['readPlanogramResult', 'body', 'history', 'planogram'],
          []
        );
        const name = safeDeepGet(
          this.props,
          ['readPlanogramResult', 'body', 'history', 'name'],
          []
        );
        const timeStamp = safeDeepGet(
          this.props,
          ['readPlanogramResult', 'body', 'history', 'time_stamp'],
          0
        );
        const user = safeDeepGet(
          this.props,
          ['readPlanogramResult', 'body', 'history', 'user'],
          []
        );
        this.setState({
          columns: columnBuilderXy(productMap, imageMap),
          columnsButton: column2BuilderXy(productMap, imageMap, buttonOptions, this.handleOnChange),
          columnsPrice: ColumnsPrice(productMap),
          planogram: buildPlanogramList(planogramMap),
          button: buildColumnList(planogramMap, productMap),
          history: history,
          name: name,
          timeStamp: timeStamp,
          user: user,
          productMap,
          imageMap,
          columnOptions,
          buttonOptions,
          planogramMap,
          waitResult,
          isLoading: false,
        });
      }
    }
    if (this.props.resultHistory !== prevProps.resultHistory) {
      const code = safeDeepGet(
        this.props,
        ['resultHistory', 'code'],
        Result.UNKNOWN_ERROR
      );
      if (code === Result.SUCCESS) {
        const body = safeDeepGet(this.props, ['resultHistory', 'body']);
        if (body != null) {
          const history = safeDeepGet(body[0], 'planogram', []);
          const name = safeDeepGet(body[0], 'name', '');
          const timeStamp = safeDeepGet(body[0], 'time_stamp', 0);
          const user = safeDeepGet(body[0], 'user', '');
          this.setState({
            history: history,
            name: name,
            timeStamp: timeStamp,
            timeStampDataBase: timeStamp,
            user: user,
          });
        }
      }
    }
    if (this.props.result !== prevProps.result) {
      const message = safeDeepGet(
        this.props,
        ['result', 'message', 'text'],
        ''
      );
      const serverless_text = safeDeepGet(
        this.props,
        ['result', 'message', 'message'],
        message
      );
      const serverless_code = safeDeepGet(
        this.props,
        ['result', 'message', 'result'],
        Result.UNKNOWN_ERROR
      );
      const ts = safeDeepGet(
        this.props,
        ['result', 'ts'],
        new Date().getTime()
      );
      const planogram_history = safeDeepGet(
        this.props,
        ['result', 'planogram_history'],
        []
      );
      const name = safeDeepGet(this.props, ['result', 'name'], this.state.name);
      this.setState({
        loading: false,
        serverless_code,
        ts,
        planogram_history,
        name,
      });

      // if (code === Result.SUCCESS) {
      //   this.showToast('Update Planogram Successful', code, mssage_serveless);
      //   setTimeout(() => window.location.reload(), 2000);
      // } else if (code !== Result.UNKNOWN_ERROR) {
      //   this.showToast('Update Planogram Failed', code, mssage_serveless);
      // }
    }
  }
  showToast(messagee, code, txt) {
    if (messagee == 'Update Planogram Successful') {
      var toastType = 'success';
      var message = messagee;
    } else {
      var toastType = 'error';
      var message = messagee + ' Kode Error: ' + code + ' ' + txt;
    }
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
    };

    if (toastType === 'info') toastr.info(message);
    else if (toastType === 'warning') toastr.warning(message);
    else if (toastType === 'error') toastr.error(message);
    else toastr.success(message);
  }
  handleCancel(event) {
    history.push('/business-point/list');
  }
  handleOnClick() {}
  handleOnChange(value, selection) {
    const { listButton, buttonValue, dataInput } = this.state;
    const selectedValue = [];
    for (const i in value) {
      selectedValue.push(value[i]);
    }
    buttonValue[selection] = selectedValue;
    dataInput[selection] = selectedValue;

    safeDeepGet(buttonValue[selection], []);
    if (value.length == 0) {
      listButton.splice(0, 0, ...removed);
      removed = [];
    }
    for (const key in value) {
      var index = listButton.indexOf(value[key]);

      if (index !== -1) {
        removed.push(value[key]);
      }
    }
  }
  handleOkClick = () => {
    const { dataPlanogram } = this.state;
    this.props.UpdatePlanogram(dataPlanogram);
    this.setState({
      confirm_alert: false,
      dynamic_title: 'Updated',
      dynamic_description: 'Planogram sudah di update',
    });
  };
  handleSubmit(event) {
    this.togglePlanogram();
    this.get_history();
    this.setState({
      loading: true,
    });

    const {
      deviceId,
      productMap,
      dataInput,
      imageMap,
      dataPrice,
      timeStampNow,
      deviceType,
      waitResult
    } = this.state;

    const data = this.tableRef.current.props.data;
    const button = this.buttonRef.current.props.data;
    const planogramMap = {};
    for (const i in data) {
      const planogram = data[i];
      const selection = planogram['selection'];
      const arr_input = dataInput[selection];
      var str = '';
      for (const i in arr_input) {
        const data_arr = safeDeepGet(arr_input[i], ['value'], []);
        const j = Number(i);
        if (j + 1 == arr_input.length) {
          str += data_arr;
        } else {
          str += data_arr + ',';
        }
      }
      const product = planogram['product'];

      let image = safeDeepGet(imageMap, product);
      if (image == '') {
        image =
          'https://firebasestorage.googleapis.com/v0/b/iotera-vending.appspot.com/o/bottleBlank.png?alt=media&token=be603fed-c9c9-4783-bf7e-d015cafc9a64';
      }
      planogramMap[selection] = {
        stock: Number(planogram['stock']),
        active: planogram['active'] == 'on',
        product,
        price: Number(planogram['price']),
        image,
        name: safeDeepGet(productMap, product, '-'),
      };
    }
    for (const i in button) {
      const planogram = button[i];
      const selection = planogram['selection'];
      const arr_input = dataInput[selection];
      var str = '';
      for (const i in arr_input) {
        const data_arr = safeDeepGet(arr_input[i], ['value'], []);
        const j = Number(i);
        if (j + 1 == arr_input.length) {
          str += data_arr;
        } else {
          str += data_arr + ',';
        }
      }

      const product = planogram['product'];
      const order = planogram['order'];
      var image = safeDeepGet(imageMap, product);
      if (image == '') {
        image =
          'https://firebasestorage.googleapis.com/v0/b/iotera-vending.appspot.com/o/bottleBlank.png?alt=media&token=be603fed-c9c9-4783-bf7e-d015cafc9a64';
      }
      this.get_history();

      planogramMap[selection] = {
        column: str,
        product,
        name: safeDeepGet(productMap, product, '-'),
        image: image,
        order: Number(order),
        price: Number(planogram['price']),
        active: planogram['active'] == 'on',
      };
    }

    this.setState({
      dataPlanogram: {
        id: deviceId,
        planogram: planogramMap,
        type: deviceType,
        device_type: deviceType,
        latest_planogram: this.state.planogramMap,
        dataPrice,
        waitResult
      },
    });
    setTimeout(
      function () {
        const body = safeDeepGet(this.props, ['resultHistory', 'body']);
        const tsData = safeDeepGet(body, [0, 'time_stamp'], 0);
        if (tsData == 0) {
          this.props.UpdatePlanogram(this.state.dataPlanogram);
        } else if (timeStampNow > tsData) {
          this.props.UpdatePlanogram(this.state.dataPlanogram);
        } else {
          this.setState({
            confirm_alert: true,
          });
        }
        //Start the timer
      }.bind(this),
      2000
    );
  }
  handleValidDate = date => {
    if (date != null || date != undefined) {
      const date1 = new Date(date).toLocaleDateString('en-GB');
      const time1 = new Date(date).toLocaleTimeString('en-GB');
      return date1 + ' ' + time1;
    } else {
      return '-';
    }
  };
  handleImage = arg => {
    const trx = arg;
    this.setState({
      trx,
    });
    // this.toggleDetail();
    window.open(arg);
  };
  render() {
    const loading = safeDeepGet(this.state, 'loading', false);
    const {
      columns,
      planogram,
      columnsButton,
      dataInput,
      button,
      history,
      name,
      timeStamp,
      user,
      ts,
      planogram_history,
      serverless_code,
      isLoading,
    } = this.state;
    const drole = localStorage.getItem('accessNav');
    const jsonRole = JSON.parse(drole);
    const guest = safeDeepGet(jsonRole, ['Business Point', 'guest'], 'off');
    const dataButton = [];
    for (const selection in dataInput) {
      const arr_input = dataInput[selection];
      var str = '';
      for (const i in arr_input) {
        const data_arr = safeDeepGet(arr_input[i], ['value'], []);
        const j = Number(i);
        if (j + 1 == arr_input.length) {
          str += data_arr;
        } else {
          str += data_arr + ', ';
        }
      }
      if (selection.slice(0, 1) != 'K') {
        dataButton.push({ key: selection, value: str });
      }
    }
    const columnList = safeDeepGet(
      this.props,
      ['readPlanogramResult', 'column'],
      []
    );
    const type = safeDeepGet(this.props, ['readPlanogramResult', 'type'], []);
    const dataColumn = [];
    for (const selection in columnList) {
      const column = columnList[selection];
      dataColumn.push({ key: column, value: str });
    }

    const filename = name + '_' + '_' + this.handleValidDate(timeStamp);
    const windowDimension = window.innerWidth;
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{buildTitle('Planoggram')}</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="Business Point" breadcrumbItem="Planogram" />
            {this.state.confirm_alert ? (
              <SweetAlert
                title="Terdapat data planogram baru"
                warning
                showCancel
                confirmButtonText="Ya, Update dengan data baru!"
                cancelBtnText="Tidak, Resfresh page"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.handleOkClick()}
                onCancel={() => window.location.reload()}
              >
                Apakah anda yakin akan melakukan update data?
              </SweetAlert>
            ) : null}
            {this.state.success_dlg ? (
              <SweetAlert
                success
                title={this.state.dynamic_title}
                onConfirm={() => this.setState({ success_dlg: false })}
              >
                {this.state.dynamic_description}
              </SweetAlert>
            ) : null}
            <Row>
              <Col lx="8">
                <div className="accordion accordion-flush" id="accordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button fw-medium mb-4 h5"
                        type="button"
                        onClick={this.t_col2}
                        style={{ cursor: 'pointer' }}
                      >
                        Column Vending Machine
                      </button>
                    </h2>

                    <Collapse
                      isOpen={this.state.col2}
                      className="accordion-collapse"
                    >
                      <Card>
                        <CardBody>
                          <CardTitle className="mb-4 h5"></CardTitle>
                          {isLoading ? (
                            <div className="text-center">
                              <CircularProgress className="text-center"></CircularProgress>
                            </div>
                          ) : (
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField="selection"
                                bootstrap4={true}
                                data={planogram}
                                columns={columns}
                                cellEdit={cellEditFactory({
                                  mode: 'click',
                                  blurToSave: true,
                                })}
                                bordered={false}
                                ref={this.tableRef}
                              />
                            </div>
                          )}
                        </CardBody>
                      </Card>
                    </Collapse>
                  </div>
                </div>
                <Col>
                  <Card>
                    <CardBody>
                      <CardTitle className="mb-4 h5">
                        Latest Changes Planogram by
                      </CardTitle>

                      <Row className="align-items-center">
                        <Col lg="9" className="align-self-center">
                          <div className="table-responsive">
                            <Table className="table align-middle table-nowrap table-hover mb-0">
                              <thead>
                                <tr>
                                  <th scope="col">Email</th>
                                  <th scope="col">Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{user}</td>
                                  <td>
                                    {timeStamp == null
                                      ? '-'
                                      : this.handleValidDate(timeStamp)}
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </Col>

                        <Col
                          lg="3"
                          className="d-none d-lg-block"
                          align="center"
                        >
                          <div className="clearfix mt-4 mt-lg-0">
                            <ExcelFile
                              filename={filename}
                              element={
                                <button
                                  type="button"
                                  className="btn btn-primary w-sm"
                                >
                                  <i className="mdi mdi-download d-block font-size-16"></i>
                                  Download
                                </button>
                              }
                            >
                              <ExcelSheet data={history} name="Planogram">
                                <ExcelColumn label="Selection" value="key" />
                                <ExcelColumn label="Product" value="name" />
                                <ExcelColumn
                                  label="Product SKU"
                                  value="product"
                                />
                                <ExcelColumn
                                  label="Product Price"
                                  value="price"
                                />
                                <ExcelColumn label="Stock" value="stock" />
                                <ExcelColumn label="Active" value="active" />
                                <ExcelColumn label="Column" value="column" />
                              </ExcelSheet>
                            </ExcelFile>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Col>
              <Col xl="4">
                <Row>
                  <ColumnLayout dataButton={dataButton}></ColumnLayout>
                </Row>
                <Row></Row>
                <div
                  style={{
                    // backgroundColor: 'blue',
                    position: 'fixed',
                    bottom: '20px',
                    right: '80px',
                    // width: '600px',
                    height: '50px',
                    // display: 'flex',
                    // justifyContent: 'center',
                    // alignItems: 'center',
                    // boxShadow: '0 2px 10px rgba(0, 0, 0, 0.15)',
                    zIndex: 999,
                  }}
                >
                  <Row>
                    <Col
                      sm="6"
                      className="mt-3"
                      style={{
                        padding: '0px',
                        width: '200px',
                      }}
                      s
                    >
                      <p className="text-start" style={{ fontSize: '10px' }}>
                        Latest Planogram{' '}
                        {timeStamp == null
                          ? '-'
                          : this.handleValidDate(timeStamp)}
                      </p>
                    </Col>
                    <Col
                      sm="6"
                      style={{
                        padding: '0px',
                        width: '200px',
                      }}
                    >
                      {isLoading ? (
                        <div className="d-flex flex-wrap gap-2 float-end ">
                          <Link
                            to="/business-point/list"
                            color="secondary"
                            className="btn btn-secondary"
                            role="button"
                            // onClick={this.handleCancel}
                            disabled={loading}
                          >
                            Cancel
                          </Link>{' '}
                          {loading ? (
                            <button type="button" className="btn btn-dark ">
                              <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{' '}
                              Loading
                            </button>
                          ) : guest == 'off' ? (
                            <Button
                              color="primary"
                              onClick={() => this.componentDidMount()}
                              disabled={loading}
                            >
                              Refresh
                            </Button>
                          ) : (
                            <></>
                          )}
                        </div>
                      ) : (
                        <div className="d-flex flex-wrap gap-2 float-end ">
                          <Link
                            to="/business-point/list"
                            color="secondary"
                            className="btn btn-secondary"
                            role="button"
                            // onClick={this.handleCancel}
                            disabled={loading}
                          >
                            Cancel
                          </Link>{' '}
                          {loading ? (
                            <button type="button" className="btn btn-dark ">
                              <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{' '}
                              Loading
                            </button>
                          ) : guest == 'off' ? (
                            <Button
                              color="primary"
                              onClick={this.handleSubmit}
                              disabled={loading}
                            >
                              Simpan
                            </Button>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
               
              </Col>
            </Row>

            <Row>
              <Col lx="8">
                <div className="accordion accordion-flush" id="accordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button fw-medium mb-4 h5"
                        type="button"
                        onClick={this.t_col1}
                        style={{ cursor: 'pointer' }}
                      >
                        Button Vending Machine
                      </button>
                    </h2>

                    <Collapse
                      isOpen={this.state.col1}
                      className="accordion-collapse"
                    >
                      <Card>
                        <CardBody>
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="selection"
                              // data={planogram}
                              columns={columnsButton}
                              data={button}
                              cellEdit={cellEditFactory({
                                mode: 'click',
                                blurToSave: true,
                              })}
                              bordered={false}
                              // ref={this.tableRef}
                              ref={this.buttonRef}
                            />
                          </div>
                        </CardBody>
                      </Card>
                    </Collapse>
                  </div>
                </div>
              </Col>
              <Col xl="4">
                <Row>
                  <VMLayout type={type} dataColumn={dataColumn}/>
                </Row>
                <Row></Row>
              </Col>
            </Row>

            <ModalNotification
              ts={ts}
              planogram_history={planogram_history}
              serverless_code={serverless_code}
              handleValidDate={this.handleValidDate}
              togglePlanogram={this.togglePlanogram}
              modalPlanogram={this.state.modalPlanogram}
            ></ModalNotification>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  readPlanogramResult: safeDeepGet(
    state,
    ['businessPoint', 'readPlanogramRetail'],
    {}
  ),
  loading: safeDeepGet(state, ['businessPoint', 'loading'], true),
  result: safeDeepGet(state, ['businessPoint', 'updatePlanogramRetail'], {}),
  resultHistory: safeDeepGet(state, ['businessPoint', 'list_history'], {}),
  test: state,
});

const mapDispatchToProps = dispatch => ({
  ReadPlanogram: id => dispatch(readPlanogramRetail(id)),
  GetHistory: payload => dispatch(list_history(payload)),
  UpdatePlanogram: payload => dispatch(updatePlanogramRetail(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessPointPlanogram);